export default "__VITE_ASSET__BlnGYgyM__"